export const sources={};export const img={src:"__VITE_ASSET__hO4dd8ILk$iZF7aFIOUkdg__",w:640,h:640};export default{sources:sources,img:img};